import axiosPost from '../axiosPost';

export const conciliacionesGireRevisar = async (arg) => {
    const { operaciones, comentario } = arg

    const body = {
        "service": "GireConciliacionRevisar",
        "params": {
            "gireConciliacionOperaciones": operaciones,
            "gireConciliacionObservacion": comentario
        }
    };

    try {
        const result = await axiosPost('Y', body, arg)
        return result.data
    } 
    catch (err) {
        console.log(err)
    };
};